/**
 * index.ts - All preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Added infrastructure, data, integration, and business modules
 * - 251031_1153 danielbeer: Added Aggregatr and FileMaker modules
 * - 251030_1003 [pending] danielbeer: Added services modules
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export * from './system';
export * from './general';
export * from './services';
export * from './ui';
export * from './infrastructure';
export * from './data';
export * from './integration';
export * from './business';
export { aggregatrModule } from './AggregatrModule';
export { filemakerModule } from './FileMakerModule';

import { systemModules } from './system';
import { generalModules } from './general';
import { notificationsModule, mailServerModule } from './services';
import { uiModules } from './ui';
import { infrastructureModules } from './infrastructure';
import { dataModules } from './data';
import { integrationModules } from './integration';
import { businessModules } from './business';
import { aggregatrModule } from './AggregatrModule';
import { filemakerModule } from './FileMakerModule';

/**
 * All standard preference modules
 */
export const standardModules = [
  ...generalModules,
  ...systemModules,
  ...uiModules,
  ...infrastructureModules,
  ...dataModules,
  ...integrationModules,
  ...businessModules,
  notificationsModule,
  mailServerModule,
  aggregatrModule,
  filemakerModule
];

/**
 * Register all standard modules with ConfiggrManager
 */
export function registerStandardModules(configgr): void {
  standardModules.forEach(module => {
    configgr.registerModule(module);
  });
}

export default standardModules;
